<template>
    <div>
        <ul class="nav nav-pills nav-tabs mb-4" id="pills-tab">
            <li v-for="(item, index) in tabs" :key="index" class="nav-item mr-4">
                <button class="nav-tabs__button" :class="getClassNavPillsButton(index, item)" :id="'pills-' + getID(index) + '-tab'" data-bs-toggle="pill" :data-bs-target="'#pills-' + getID(index)"
                    type="button" role="tab" :aria-controls="'pills-' + getID(index)" aria-selected="true" :disabled="disabled">{{ index }}</button>
            </li>
        </ul>
        <div class="tab-content" id="pills-tabContent">
            <slot></slot>
        </div>
    </div>
</template>

<style lang="sass">
.nav.nav-pills
    background: unset!important
.nav-tabs
    background-color: #f8f9fa
    border-radius: 0px
    padding: 0px
    list-style: none
    display: flex
    border-bottom: 0px
    margin: 0px
    li
        padding: 6px
        background-color: #fff
    &__button
        background-color: #fff
        border-radius: 4px !important
        border: none !important
        padding: 10px 16px !important
        font-size: 14px 
        font-weight: 700
        color: #344767
        opacity: 0.5
        transition: all 0.3s ease-in
        &:hover
            opacity: 1
        &.active
            background-color: #cde8ff !important
            opacity: 1
</style>

<script>
export default {
    name: "tabbed-pane",
    props: {
        tabs: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        getClassNavPillsButton(index, item) {
            return {
                'nav-link': true,
                'nav-link-tab': true,
                'active': item,
            };
        },
        getID(item) {
            return String(item).toLowerCase().split(' ').join('-');
        }
    },
}
</script>